import React from 'react';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import { TableCell } from 'semantic-ui-react';

import { AppState } from 'services/types';
import { SprayEventForSubmission } from 'services/sprayEventsForSubmission/types';
import { makeSelectParentEntityNames } from './selectors';

export interface OwnProps {
    sprayEventId: SprayEventForSubmission['id'];
}

interface ConnectedProps {
    parentEntityNames?: string;
}

type Props = OwnProps & ConnectedProps;

export class RenderSubmissionSprayEventsTableRowParentEntitiesCellComponent extends React.PureComponent<
    Props
> {
    render(): React.ReactElement {
        const { parentEntityNames } = this.props;

        return (
            <TableCell textAlign="left" className="events-table-cell-padding">
                {parentEntityNames}
            </TableCell>
        );
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    parentEntityNames: makeSelectParentEntityNames()
});

export default connect(mapStateToProps)(
    RenderSubmissionSprayEventsTableRowParentEntitiesCellComponent
);
